import React, { useEffect, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { getUserId } from "../../../Utils/Common/Library";
import { fetchData } from "./api";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetTeamPlan } from "../../../Redux/Actions/TeamPlanActions";

const TeamPlanTable = ({ relationshipType, period }) => {
  const gridRef = useRef();
  const history = useHistory();
  const dispatch = useDispatch();

  const [columnDefs] = useState([
    {
      field: "AppraiseeUserFullName",
      headerName: "Employee Name",
      cellRenderer: "agGroupCellRenderer",
      flex: 1,
      showRowGroup: true,
      filter: "agTextColumnFilter",
    },
    { field: "PlanPeriod", flex: 1, filter: "agTextColumnFilter" },
    {
      field: "AppraiseeUserEmployeeCode",
      headerName: "Employee Code",
      flex: 1,
      filter: "agTextColumnFilter",
    },
    { field: "GoalSettingStatus", flex: 1.5 },
    { field: "CurrentStatus", flex: 1.5, headerName: "Assessment Status" },
    { field: "PlanStartDate", flex: 1 },
    { field: "PlanEndDate", flex: 1 },
    { field: "AppraiseeUserID", hide: true },
    { field: "UserType", flex: 1 },
    { field: "HIDDENval", hide: true },
  ]);

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
  };

  const [checkedForChildren, setCheckedForChildren] = useState(new Map());

  const createDataSource = () => {
    return {
      getRows: async (params) => {
        try {
          const request = params.request;
          const groupKeys = request.groupKeys || [];
          const level = groupKeys.length + 1;

          let response;
          let userIdToCheck;

          if (level === 1) {
            userIdToCheck = getUserId();
            response = await fetchData({
              userId: userIdToCheck,
              period: period,
              relationType: relationshipType,
              filterModel: request.filterModel,
              sortModel: request.sortModel,
            });
          } else {
            userIdToCheck = groupKeys[groupKeys.length - 1];
            response = await fetchData({
              userId: userIdToCheck,
              period: period,
              relationType: relationshipType,
              filterModel: request.filterModel,
              sortModel: request.sortModel,
            });
          }

          if (!response || response.length === 0) {
            params.success({
              rowData: [],
              rowCount: 0,
            });

            const newCheckedMap = new Map(checkedForChildren);
            newCheckedMap.set(userIdToCheck, false);
            setCheckedForChildren(newCheckedMap);

            return;
          }

          const rowData = response.map((row) => ({
            ...row,
            hasChildren: true,
          }));

          params.success({
            rowData,
            rowCount: response.length,
          });
        } catch (error) {
          console.error("Error loading hierarchical data:", error);
          params.fail();
        }
      },
    };
  };

  const onGridReady = (params) => {
    const dataSource = createDataSource();
    params.api.setServerSideDatasource(dataSource);
  };

  // Refresh datasource when relationshipType or period changes
  useEffect(() => {
    if (gridRef.current && gridRef.current.api) {
      const dataSource = createDataSource();
      gridRef.current.api.setServerSideDatasource(dataSource);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [relationshipType, period]);

  const isServerSideGroup = (dataItem) => {
    if (
      checkedForChildren.has(dataItem.AppraiseeUserID) &&
      !checkedForChildren.get(dataItem.AppraiseeUserID)
    ) {
      return false;
    }
    return dataItem.hasChildren !== false;
  };

  useEffect(() => {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          const targets = document.querySelectorAll(".ag-watermark");
          targets.forEach((target) => {
            target.remove();
          });
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    return () => {
      dispatch(resetTeamPlan());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="ag-theme-alpine" style={{ height: 600, width: "100%" }}>
      <AgGridReact
        ref={gridRef}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        rowModelType="serverSide"
        treeData={true}
        animateRows={true}
        serverSideStoreType="partial"
        isServerSideGroup={isServerSideGroup}
        getServerSideGroupKey={(dataItem) => dataItem.AppraiseeUserID}
        onGridReady={onGridReady}
        pagination={true}
        paginationPageSize={10}
        cacheBlockSize={100}
        suppressRowGroupHideOpenParents={true}
        autoGroupColumnDef={null}
        groupDisplayType="groupRows"
        overlayNoRowsTemplate="<span>No data available</span>"
        getRowId={(params) => {
          return params.data.AppraiseeUserID;
        }}
        onRowClicked={({ data }) => {
          console.log(data.HIDDENval, "Hidden EPP Plan Data");
          const Plan = data.HIDDENval;
          if (!Plan.Dimensions) Plan.Dimensions = [];
          if (!Plan.Sections) Plan.Sections = [];
          localStorage.setItem("EPP_NAV_LOCATION", "/myteamplan");
          history.push({ pathname: "/pms", state: { Plan } });
        }}
        gridOptions={{
          getRowClass: (params) => {
            return "pointer-row";
          },
        }}
      />
    </div>
  );
};

export default TeamPlanTable;
